(function ($) {

	function initSpecialistSingleSliders() {
		if ($('.about-gallery .gallery-slider').length) {
			new Swiper('.about-gallery .gallery-slider', {
				slidesPerView: 3,
				spaceBetween: 16,
				loop: false,
				pagination: {
					el: '.about-gallery .gallery-slider .swiper-pagination',
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 1,
				},
				navigation: {
					nextEl: '.gallery-nav--photo-next',
					prevEl: '.gallery-nav--photo-prev',
				},
				breakpoints: {
					0: { slidesPerView: 1, spaceBetween: 12 },
					576: { slidesPerView: 2, spaceBetween: 16 },
					768: { slidesPerView: 3, spaceBetween: 16 },
				},
			});
		}

		if ($('.about-gallery .videos-slider').length) {
			new Swiper('.about-gallery .videos-slider', {
				slidesPerView: 3,
				spaceBetween: 16,
				loop: false,
				observer: true,
				observeParents: true,
				pagination: {
					el: '.about-gallery .videos-slider .swiper-pagination',
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 1,
				},
				navigation: {
					nextEl: '.gallery-nav--vid-next',
					prevEl: '.gallery-nav--vid-prev',
				},
				breakpoints: {
					0: { slidesPerView: 1, spaceBetween: 12 },
					576: { slidesPerView: 2, spaceBetween: 16 },
					768: { slidesPerView: 3, spaceBetween: 16 },
				},
			});
		}

		if ($('.specialist-blog-slider').length) {
			var totalBlogSlides = $('.specialist-blog-slider .swiper-slide').length;
			new Swiper('.specialist-blog-slider', {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 16,
				grabCursor: true,
				navigation: {
					nextEl: '.gallery-nav--blog-next',
					prevEl: '.gallery-nav--blog-prev',
				},
				breakpoints: {
					768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 24 },
					1024: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 32 },
				},
				on: {
					init: function () {
						var perView = this.params.breakpoints[1024].slidesPerView;
						if (totalBlogSlides <= perView) {
							$('.specialist-blog-slider .gallery-nav').hide();
						}
					},
					resize: function () {
						var perView = this.currentBreakpoint ? this.params.breakpoints[this.currentBreakpoint].slidesPerView : this.params.slidesPerView;
						if (totalBlogSlides <= Math.ceil(perView)) {
							$('.specialist-blog-slider .gallery-nav').hide();
						} else {
							$('.specialist-blog-slider .gallery-nav').show();
						}
					},
				},
			});
		}

		if ($('.reviews-slider').length) {
			var totalSlides = $('.reviews-slider .swiper-slide').length;
			new Swiper('.reviews-slider', {
				slidesPerView: 'auto',
				spaceBetween: 32,
				centeredSlides: false,
				pagination: {
					el: '.reviews-pagination',
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 1,
				},
				breakpoints: {
					0: { slidesPerView: 1.1, spaceBetween: 16 },
					576: { slidesPerView: 1.5, spaceBetween: 20 },
					768: { slidesPerView: 2, spaceBetween: 24 },
					1024: { slidesPerView: 3, spaceBetween: 32 },
				},
				on: {
					init: function () {
						var perView = this.params.slidesPerView;
						if (typeof perView === 'string') perView = this.params.breakpoints[1024].slidesPerView;
						if (totalSlides <= perView) {
							this.pagination.el && (this.pagination.el.style.display = 'none');
							this.el.classList.add('reviews-slider--few');
						}
					},
					resize: function () {
						var perView = this.currentBreakpoint ? this.params.breakpoints[this.currentBreakpoint].slidesPerView : this.params.slidesPerView;
						if (totalSlides <= Math.floor(perView)) {
							this.pagination.el && (this.pagination.el.style.display = 'none');
							this.el.classList.add('reviews-slider--few');
						} else {
							this.pagination.el && (this.pagination.el.style.display = '');
							this.el.classList.remove('reviews-slider--few');
						}
					},
				},
			});
		}
	}

	function initSpecialistSingleCounters() {
		var grid = document.querySelector('.bignumbers-grid');
		if (!grid) return;

		var counters = grid.querySelectorAll('.bignumber-counter');
		if (!counters.length) return;

		var animated = false;

		function runCounters() {
			if (animated) return;
			animated = true;

			counters.forEach(function (el) {
				var target = parseFloat(el.dataset.target);
				var suffix = el.dataset.suffix || '';
				var isDecimal = el.dataset.decimal === 'true';
				var useDot = el.dataset.format === 'dot';
				var duration = 1500;
				var startTime = null;

				function step(timestamp) {
					if (!startTime) startTime = timestamp;
					var progress = Math.min((timestamp - startTime) / duration, 1);
					var eased = 1 - Math.pow(1 - progress, 3);
					var current = target * eased;

					if (isDecimal) {
						el.textContent = current.toFixed(1);
					} else if (useDot) {
						el.textContent = Math.floor(current).toLocaleString('pt-BR') + suffix;
					} else {
						el.textContent = Math.floor(current) + suffix;
					}

					if (progress < 1) {
						requestAnimationFrame(step);
					}
				}

				requestAnimationFrame(step);
			});
		}

		var check = setInterval(function () {
			if (grid.classList.contains('aos-animate')) {
				clearInterval(check);
				setTimeout(runCounters, 800);
			}
		}, 100);
	}

	function initSpecialistSingleInteractions() {
		$(document).on('click', '.specialist-hero__name, .specialist-hero__tagline', function () {
			var target = document.querySelector('.specialist-about');
			if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});

		$(document).on('click', '.hero-reviews-tag', function () {
			var target = document.getElementById('google-reviews-block');
			if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});

		$(document).on('click', '.btn-scroll-agendar', function (e) {
			e.preventDefault();
			var target = document.getElementById('agendar');
			if (target) {
				var calendarWidget = target.querySelector('.calendar-widget');
				var scrollTo = calendarWidget || target;
				scrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		});

		$(document).on('click', '.location-tabs__btn', function () {
			var $btn = $(this);
			var panel = $btn.data('loc-tab');
			var $section = $btn.closest('.specialist-location');

			$section.find('.location-tabs__btn').removeClass('active');
			$btn.addClass('active');

			$section.find('.location-panel').removeClass('active');
			$section.find('.location-panel[data-loc-panel="' + panel + '"]').addClass('active');

			$section.find('.location-map-frame').removeClass('active');
			$section.find('.location-map-frame[data-loc-map="' + panel + '"]').addClass('active');
		});

		$(document).on('click', '.gallery-tab', function () {
			var $tab = $(this);
			var tabName = $tab.data('tab');
			var $gallery = $tab.closest('.about-gallery');

			$gallery.find('.gallery-tab').removeClass('active');
			$tab.addClass('active');

			$gallery.find('.gallery-panel').removeClass('active');
			$gallery.find('.gallery-panel[data-panel="' + tabName + '"]').addClass('active');
		});
	}

	$(function () {
		if (!$('.specialist-page').length && !$('body.single-post_especialistas').length) {
			return;
		}

		initSpecialistSingleSliders();
		initSpecialistSingleCounters();
		initSpecialistSingleInteractions();
	});

})(jQuery);
